import styles from './InputDescription.module.scss';

interface InputDescriptionProps {
  children: React.ReactNode;
  id: string;
}

export const InputDescription = ({ children, id }: InputDescriptionProps) => (
  <p className={styles.description} id={id}>
    {children}
  </p>
);
